var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 642,
    viewBox: "0 0 642 642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0662202,
    cx: 321,
    cy: 321,
    r: 321,
    fill: "url(#paint0_radial_2730_5556)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.122861,
    cx: 321,
    cy: 319,
    r: 235,
    fill: "url(#paint1_radial_2730_5556)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.995 437.904C245.063 446.337 248.704 456.357 257.128 460.285C257.943 460.665 258.759 461.037 259.577 461.401C258.147 461.138 256.725 460.69 255.344 460.046C253.457 459.166 251.592 458.251 249.749 457.302C241.29 452.947 237.92 442.665 242.22 434.337C246.521 426.008 256.864 422.787 265.322 427.142C266.362 427.677 267.411 428.198 268.469 428.706C260.763 426.705 252.483 430.423 248.995 437.904ZM268.469 428.706C269.448 428.96 270.417 429.306 271.367 429.749C330.141 457.156 400.026 431.68 427.461 372.847C454.895 314.014 429.489 244.103 370.715 216.696C313.897 190.202 246.329 213.098 217.203 268.392C212.868 276.624 202.686 279.785 194.463 275.452C186.24 271.12 183.089 260.935 187.425 252.703C224.916 181.527 311.845 152.069 384.954 186.16C460.575 221.423 493.264 311.374 457.966 387.072C423.048 461.953 334.681 494.836 259.577 461.401C267.075 462.78 274.802 459.079 278.129 451.945C282.091 443.451 278.312 433.304 269.69 429.283C269.282 429.093 268.875 428.9 268.469 428.706Z",
    fill: "url(#paint2_linear_2730_5556)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2730_5556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.654 237.419) rotate(90) scale(642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002B5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2730_5556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.407 257.811) rotate(90) scale(470)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002B5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2730_5556",
    x1: 100.288,
    y1: 279.487,
    x2: 160.177,
    y2: 456.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4C4",
    stopOpacity: 0.01
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.28b61ef9.svg";
export { ForwardRef as ReactComponent };